
<p-table #reqlist [columns]="cols" [value]="requisitions" [lazy]="true" (onLazyLoad)="loadRequisitionsLazy($event)" [paginator]="true"
         [rows]="20" [totalRecords]="totalRecords" [loading]="loading">
  <ng-template pTemplate="caption" [style]="{'height':'30px !important'}">
    <div style="height: 30px; width: 100%">
      <span class="float-left">Lab Requisition List</span>
      <div class="float-right ml-4">
        <a (click)="reqlist.filter('', 'Accession', 'equals')" class="text-white" style="font-size: 24px" href="javascript:void(0)"><i class="fa-refresh fa"></i> </a>
      </div>
      <div class="float-right ml-4">
        <input pInputText type="text" (keypress)="handleSearchKey($event, reqlist)" placeholder="Requisition Search" />
      </div>
      <div class="float-right text-white font-weight-bold">
        {{totalRecords | number}} rows
      </div>

    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width, 'padding-bottom': '0px', 'border-bottom': '0px'}">
        {{col.header}}
        <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
      </th>
    </tr>
    <tr>
      <th *ngFor="let col of columns" [ngSwitch]="col.field" style="padding: 3px 3px 3px 3px; border-top: 0px">
        <kendo-textbox *ngSwitchCase="'RequisitionExceptions'" style="width: 95%" placeholder="=any, =current" (valueChange)="addFilter(col.field, $event)" (keydown)="filterKeyPress($event, reqlist)"></kendo-textbox>
        <kendo-textbox *ngSwitchDefault style="width: 95%" placeholder="" (valueChange)="addFilter(col.field, $event)" (keydown)="filterKeyPress($event, reqlist)"></kendo-textbox>
      </th>
    </tr>

  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" [ngSwitch]="col.field">
        <span *ngSwitchDefault>{{rowData[col.field]}}</span>
        <span *ngSwitchCase="'Accession'"><a (click)="showDetail(rowData.Accession)" href="javascript:void(0)">{{rowData[col.field]}}</a></span>
        <span *ngSwitchCase="'BirthDate'">{{rowData[col.field] | date:'MM/dd/yyyy'}}</span>
        <span *ngSwitchCase="'DateOfService'">{{rowData[col.field] | date:'short'}}</span>
        <span *ngSwitchCase="'DateReceived'">{{rowData[col.field] | date:'short'}}</span>
        <span *ngSwitchCase="'StatusDate'">{{rowData[col.field] | date:'short'}}</span>
        <span *ngSwitchCase="'PatientName'">{{rowData["FirstName"]}} {{rowData["LastName"]}}</span>
        <div *ngSwitchCase="'RequisitionTests'"><p *ngFor='let test of rowData["TestNames"]'>{{test}}</p></div>
        <div *ngSwitchCase="'RequisitionExceptions'"><p *ngFor="let exc of rowData[col.field]" [ngClass]="{'strikethrough': exc.Resolved }">{{exc.IssueDescription}}</p></div>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-dialog [(visible)]="showDetailDialog" [modal]="true" [closable]="false">
  <ng-template #header>
    Requisition Detail
  </ng-template>
  <div style="height: 450px;">
    <app-receiving-sample *ngIf="detailId > 0" [requisitionId]="detailId"> </app-receiving-sample>
  </div>
  <ng-template #footer>
    <button (click)="hideDetail()" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-times"></i> Close
    </button>
  </ng-template>
</p-dialog>
